import { authApi } from '@/utils/api'

const AUTH_KEY = 'ff_token'
const USER_KEY = 'ff_user'

export default {
  namespaced: true,

  state: {
    token: localStorage.getItem(AUTH_KEY) || null,
    user: JSON.parse(localStorage.getItem(USER_KEY) || 'null')
  },

  getters: {
    isLoggedIn: state => !!state.token,
    isAdmin: state => state.user && ['admin', 'super_admin'].includes(state.user.role),
    isSuperAdmin: state => state.user && state.user.role === 'super_admin',
    isMember: state => state.user && state.user.role === 'member',
    currentUser: state => state.user,
    currentUsername: state => state.user ? state.user.username : ''
  },

  mutations: {
    SET_AUTH(state, { token, user }) {
      state.token = token
      state.user = user
      localStorage.setItem(AUTH_KEY, token)
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    },
    CLEAR_AUTH(state) {
      state.token = null
      state.user = null
      localStorage.removeItem(AUTH_KEY)
      localStorage.removeItem(USER_KEY)
    },
    UPDATE_USER(state, user) {
      state.user = user
      localStorage.setItem(USER_KEY, JSON.stringify(user))
    }
  },

  actions: {
    async login({ commit }, { username, password }) {
      const result = await authApi.login({ username, password })
      commit('SET_AUTH', { token: result.token, user: result.user })
      return result.user
    },

    async register({ commit }, { username, birthday, password }) {
      const result = await authApi.register({ username, birthday, password })
      commit('SET_AUTH', { token: result.token, user: result.user })
      return result.user
    },

    logout({ commit }) {
      commit('CLEAR_AUTH')
    },

    async fetchMe({ commit }) {
      try {
        const user = await authApi.me()
        commit('UPDATE_USER', user)
      } catch (e) {
        commit('CLEAR_AUTH')
      }
    }
  }
}
